import React, { useState } from "react";
import { ProfileWrapper } from '@/shared/components/CardWrapper'
import { useTranslation } from "react-i18next";
import { AddMemberButton } from '@/features/profile/members/AddMemberButton'
import { AddMemberForm } from '@/features/profile/members/AddMemberForm'
import { MembersTable } from '@/features/profile/members/MembersTable'

const Members = () => {
    const { t } = useTranslation();
    const [showNewUserForm, setShowNewUserForm] = useState(false)

    const updateShowUserFormState = (state) => {
      setShowNewUserForm(state)
    }

    return (
        <ProfileWrapper
          title={t("profile.tabs.members")}
          description={t("profile.members.description")}
          hasButton={true}
          buttonContent={<AddMemberButton showNewUserForm={showNewUserForm} setShowNewUserForm={updateShowUserFormState}/>}
        >
            {!!showNewUserForm ?
              <AddMemberForm onSuccess={() => setShowNewUserForm(false)} />
              :
              <MembersTable
                showNewUserForm={showNewUserForm}
                setShowNewUserForm={updateShowUserFormState}
              />
            }
        </ProfileWrapper>
    );
};

export default Members;
